import { render, staticRenderFns } from "./EcommerceTable.vue?vue&type=template&id=4ddf2cb7"
import script from "./EcommerceTable.vue?vue&type=script&lang=js"
export * from "./EcommerceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports